<template>
  <base-container ref="container" :isLoading="loading">
    <el-container style="height: 100%">
      <el-header height="40px" style="line-height: 40px">
        病区：
        <el-select
          filterable
          style="margin-right: 20px; width: 300px"
          size="mini"
          v-model="wardId"
          @change="wardChange"
        >
          <el-option
            v-for="ward in wards"
            :key="ward.id"
            :value="ward.id"
            :label="ward.name"
          ></el-option>
        </el-select>
      </el-header>
      <el-main style="padding: 0 10px">
        <el-calendar style="margin-left: 10px" v-model="date" ref="calendar">
        </el-calendar>
      </el-main>
    </el-container>
  </base-container>
</template>

<script>
import { getWards } from "@/api/bed/ward";
import moment from "moment";
export default {
  data() {
    return {
      loading: false,
      wards: [],
      wardId: "",
    };
  },
  created() {
    getWards().then((res) => {
      this.wards = res.data.data;
    });
  },
  methods: {
    wardChange() {},
  },
};
</script>

<style scoped></style>
